import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "news-title" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("News and Ayalysis")
const _hoisted_3 = { class: "list pb-16" }
const _hoisted_4 = { class: "items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_TheHot = _resolveComponent("TheHot")
  const _component_ThePostItem = _resolveComponent("ThePostItem")
  const _component_TheNewsItem = _resolveComponent("TheNewsItem")
  const _component_TheAnalysisItem = _resolveComponent("TheAnalysisItem")
  const _component_Line = _resolveComponent("Line")
  const _component_List = _resolveComponent("List")
  const _component_Holder = _resolveComponent("Holder")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_t, {
        path: "home_8",
        class: "f-nm f-bold c-text"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.topics && _ctx.topics.length)
        ? (_openBlock(), _createBlock(_component_TheHot, {
            key: 0,
            topics: _ctx.topics
          }, null, 8, ["topics"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Holder, { content: _ctx.listData }, {
        default: _withCtx(() => [
          _createVNode(_component_List, {
            "list-data": _ctx.listData,
            "pull-refresh": "",
            onRefresh: _ctx.refresh
          }, {
            default: _withCtx(({ item }) => [
              _createVNode("div", _hoisted_4, [
                (item.type === 0)
                  ? (_openBlock(), _createBlock(_component_ThePostItem, {
                      key: 0,
                      post: item.userPostModel,
                      noPin: ""
                    }, null, 8, ["post"]))
                  : _createCommentVNode("", true),
                (item.type === 1)
                  ? (_openBlock(), _createBlock(_component_TheNewsItem, {
                      key: 1,
                      news: item.appcontentArticleModel
                    }, null, 8, ["news"]))
                  : _createCommentVNode("", true),
                (item.type === 2)
                  ? (_openBlock(), _createBlock(_component_TheAnalysisItem, {
                      key: 2,
                      advice: item.tradOpptortunitiesModel
                    }, null, 8, ["advice"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Line)
              ])
            ]),
            _: 1
          }, 8, ["list-data", "onRefresh"])
        ]),
        _: 1
      }, 8, ["content"])
    ])
  ]))
}